import { render, staticRenderFns } from "./DashboardImage.vue?vue&type=template&id=d5191db8&scoped=true&"
import script from "./DashboardImage.vue?vue&type=script&lang=ts&"
export * from "./DashboardImage.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardImage.vue?vue&type=style&index=0&id=d5191db8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5191db8",
  null
  
)

export default component.exports